
    import Vue from 'vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import ILocationSearchType from '../../interfaces/ilocation-search-type';
import ILocation from '../../interfaces/ilocation';
import {isNativeApp} from '../../utils/browser';
import {ILocationType} from '../../interfaces/location-type-enum';
import EmblaCarousel, {EmblaCarouselType,EmblaEventType} from 'embla-carousel';

    declare const Alkami: any;

export default Vue.extend({
  name: 'locations-list',
  data() {
    return {
      Alkami,
      isVisible: false,
      LocationFilterResults: '',
      BranchLocationType: ILocationType.Branch,
      AtmLocationType: ILocationType.ATM,
      Locations: [] as ILocation[],
      isNativeAppClass: isNativeApp(),
      embla: {} as EmblaCarouselType
    };
  },
  computed: {
    ...mapGetters(
      [
        'getAllLocationSearchTypes',
        'getCheckedLocationSearchTypes',
        'getAllLocations',
        'getEmblaScrollToIndex',
        'getUsedMyLocation'
      ]
    ),
    IsLoading: {
      get(): boolean {
        return this.$store.state.IsLoading;
      }
    },
  },
  watch: {
    getAllLocations(value: ILocation[]) {
      this.Locations = value;
      if (this.Locations) {
        this.updateGMapAsync('mobile');
      }
      this.initEmblaCarousel();
    },
    getEmblaScrollToIndex(value: number) {
      try {
        this.embla.scrollTo(value);
      } catch (e) {
        console.log(e);
      }
      this.focusLocation(value);
    }
  },
  methods: {
    ...mapMutations(['setSelectedLocation', 'setEmblaScrollToIndex', 'setIsLoading']),
    ...mapActions(['initGMapComponentsAsync', 'updateGMapAsync', 'focusLocation']),
    initEmblaCarousel() {
      // Give Embla a chance to hook into the HTML when it's ready
      setTimeout(() => {
        let viewport = document.querySelector('.embla__viewport');
        if (viewport === null) {
          return;
        }
        this.embla = EmblaCarousel(viewport as HTMLElement, {
          draggable: true,
          loop: true
        });
        this.embla.slideNodes().forEach((slideNode, index) => {
          slideNode.addEventListener('click', () => {
            this.setSelectedLocation(this.Locations[index]);
            this.$router.replace({name: 'details'});
          }, false);
        });
        this.embla.on('select', () => this.setEmblaScrollToIndex(this.embla.selectedScrollSnap()));
      }, 1);
    }
  },
  async mounted() {
    this.setEmblaScrollToIndex(-1);
    await this.initGMapComponentsAsync(this.getUsedMyLocation ? 'mobile-UseMyLocation' : 'mobile-ByAddress');
    this.LocationFilterResults = this.getAllLocationSearchTypes && this.getAllLocationSearchTypes.length > 0
      ? 'All Results' : this.getCheckedLocationSearchTypes.map((lst: ILocationSearchType) => lst.LocationTypeName).join(', ');
    this.setEmblaScrollToIndex(0);
  }
});
